import React, { useEffect, useState } from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';

import { getInterestRate } from '../../domains/interestRate/getInterestRate';
import { useGetContracts } from '../CreditCardConditions/hooks/useGetContracts';

import Title from './patterns/Title/Title';
import Conditions from './patterns/Conditions/Conditions';
import ComponentDefaultProps from './variant/CreditCardNuControlConditionsProps';

const {
  conditions,
} = ComponentDefaultProps;

const CreditCardNuControlConditions = () => {
  const [interestRate, setInterestRate] = useState(null);
  const fetchInterestRateInfo = async () => {
    try {
      const interestRateInfo = await getInterestRate();
      setInterestRate(interestRateInfo);
    } catch (error) {
      setInterestRate(null);
    }
  };

  useEffect(() => {
    fetchInterestRateInfo();
  }, []);

  const contracts = useGetContracts('fee-card');

  return (
    <Box marginBottom="8x">
      <Title />
      <Conditions interest={interestRate} conditions={conditions} contracts={contracts} />
      <br />
      <br />
    </Box>
  );
};

export default CreditCardNuControlConditions;
